"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateVO = void 0;
const base_1 = require("../base");
class DateVO extends base_1.ValueObject {
    static fromDate(date) {
        return new DateVO(date);
    }
    static fromDateString(dateString) {
        return new DateVO(new Date(dateString));
    }
    static fromISOString(isoString) {
        const date = new Date(isoString);
        return new DateVO(date);
    }
    static fromTimestamp(timestamp) {
        return new DateVO(new Date(timestamp));
    }
    static now() {
        return new DateVO(new Date());
    }
    getAgeInYears() {
        const today = new Date();
        let age = today.getFullYear() - this._value.getFullYear();
        const monthDiff = today.getMonth() - this._value.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < this._value.getDate())) {
            age--;
        }
        return age;
    }
    getTimestamp() {
        return this._value.getTime();
    }
    isAfter(other) {
        return this._value > other._value;
    }
    isBefore(other) {
        return this._value < other._value;
    }
    isToday() {
        const today = new Date();
        return this.toDateString() === today.toISOString().split('T')[0];
    }
    toDateString() {
        const isoString = this._value.toISOString();
        const datePart = isoString.split('T')[0];
        if (!datePart) {
            throw new Error('Failed to extract date part from ISO string');
        }
        return datePart;
    }
    toDisplayString() {
        return this._value.toLocaleString('en-CA', {
            day: '2-digit',
            hour: '2-digit',
            hour12: false,
            minute: '2-digit',
            month: '2-digit',
            second: '2-digit',
            year: 'numeric',
        });
    }
    toISOString() {
        return this._value.toISOString();
    }
    getEqualityComponents() {
        return [this._value.getTime()];
    }
    isEqual(other) {
        return this._value.getTime() === other._value.getTime();
    }
    validate() {
        if (!(this._value instanceof Date)) {
            throw new Error('Date must be a Date object');
        }
        if (isNaN(this._value.getTime())) {
            throw new Error('Date must be a valid date');
        }
    }
}
exports.DateVO = DateVO;
